export const privacyPolicyText = `
APP Privacy Policy
I. Introduction
We respect the privacy of our users and are committed to safeguarding the personal information collected through our APP. This Privacy Policy outlines our practices regarding the collection, use, storage, and disclosure of personal information when you use our APP available on the Google Play Store.

II. Collection of Personal Information
1.Voluntary Information: When you use our APP, you may be prompted to provide personal information such as your name, email address, phone number, and other relevant details. This information is collected when you voluntarily submit it through various features or functionalities of the APP.
2.Automatic Collection: Our APP may automatically collect certain non-personal information about your device and usage patterns, including but not limited to device model, operating system, IP address, browser type, and usage statistics. This information helps us understand how our APP is being used and to improve its performance.
3.Others:In this app, we need to obtain the network usage rights of the phone, as well as some advertising usage rights.

III. Use of Personal Information
We use the personal information collected through our APP for the following purposes:
1.To provide you with the requested services and features of our APP.
2.To communicate with you, including responding to your inquiries, providing updates, and sending promotional messages (subject to your preferences).
3.To personalize your experience by customizing the content and features of our APP based on your preferences and usage patterns.
4.To improve our APP by analyzing user behavior and feedback.
5.To comply with legal obligations and respond to lawful requests from government authorities.

IV. Sharing of Personal Information
We may share personal information with third parties in the following circumstances:
1.With service providers who perform functions on our behalf, such as hosting, data analysis, and payment processing. These service providers are contractually obligated to keep your information secure and confidential.
2.If required by law or in response to a subpoena, court order, or other legal process.
3.In the event of a merger, acquisition, or sale of assets, personal information may be transferred as part of the transaction.

V. Security of Personal Information
We employ reasonable security measures to protect the confidentiality and integrity of personal information collected through our APP. 

VI. User Rights and Choices
You have the right to:
1.Request access to, correction, or deletion of your personal information.
2.Withdraw your consent to the collection, use, and sharing of your personal information at any time, subject to legal and contractual restrictions.
3.Opt-out of receiving promotional communications from us.

VII. Updates to Privacy Policy
We reserve the right to update this Privacy Policy at any time to reflect changes in our practices or legal requirements. Updated versions of the Privacy Policy will be posted on our APP. Your continued use of our APP after any such changes constitutes your acceptance of the revised Privacy Policy.

VIII. Contact Information
If you have any questions or concerns regarding this Privacy Policy, please contact us at 163@163.com.

IX. Governing Law
This Privacy Policy is governed by the laws of the relevant country or region. Any disputes arising from this Privacy Policy shall be subject to the jurisdiction of the courts of the relevant country or region.
By downloading, installing, and using our APP on the Google Play Store, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy. 
`;

export const gameName = {
    key: 5,
    objs: {
        0: {
            name: 'Lucky PG Party Game',
            email: 'brunocamillo8@gmail.com',
        },
        1: {
            name: 'Royal Pg Gold World',
            email: 'okemama.digital@gmail.com',
        },
        2: {
            name: 'Happy Spin Realm',
            email: 'bazarbd.web@gmail.com',
        },
        3: {
            name: 'Royal Panda Game',
            email: 'rahatitsolution@gmail.com',
        },
        4: {
            name: 'Golden Cat Reel Spin',
            email: 'azrafatoufiq@gmail.com',
        },
        5: {
            name: 'Super Lion Game',
            email: 'free.lancer.wordpress.92@gmail.com',
        },

    }
}